import { render, staticRenderFns } from "./cars.vue?vue&type=template&id=65e6a220&scoped=true&"
import script from "./cars.vue?vue&type=script&lang=js&"
export * from "./cars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6a220",
  null
  
)

export default component.exports